import { createDeleteDeviceMutations, Device } from 'shared/api';
import { ConfirmModalModel, createConfirmModalModel, declareModalData } from 'shared/lib';

export type DeleteDeviceModel = ConfirmModalModel<Device, number, null>;

export const createDeleteDeviceModel = (): DeleteDeviceModel => {
	const deleteDeviceMutation = createDeleteDeviceMutations();

	const model = createConfirmModalModel<Device, number, null>({
		modalData: declareModalData<Device>(),
		mapModalData: ({ id }) => id,
		mutation: deleteDeviceMutation,
		successMessageKey: 'delete-device.success',
	});

	return model;
};
